import { useFetch, setDedupingIntervals } from '@stashinvest/use-fetch';

export const stashWorksStatus = {
	ACTIVE: 'ACTIVE',
	INACTIVE: 'INACTIVE',
	OFFBOARDING: 'OFFBOARDING',
	NOT_FOUND: 'NOT_FOUND',
} as const;

type StashWorksStatus = (typeof stashWorksStatus)[keyof typeof stashWorksStatus];

type StashWorksStatusResponse = {
	data?: {
		status?: StashWorksStatus;
	};
};

type UseStashWorksStatusResult = {
	status: StashWorksStatus | undefined;
	hasStashWorks: boolean;
	isLoading: boolean;
};

const stashWorksStatusPath = '/apis/works/v1/users/:uuid/status';

setDedupingIntervals({
	[stashWorksStatusPath]: 1000 * 60 * 60,
});

export const useStashWorksStatus = (): UseStashWorksStatusResult => {
	const { data: response, error } = useFetch<StashWorksStatusResponse>({
		path: stashWorksStatusPath,
		onMount: true,
	});

	const status = response?.data?.status;

	const hasStashWorks =
		status === stashWorksStatus.ACTIVE || status === stashWorksStatus.OFFBOARDING;

	const isLoading = !response && !error;

	return {
		status,
		hasStashWorks,
		isLoading,
	};
};
